// src/context/LoaderContext.js
import React, { createContext, useEffect, useState, useCallback } from "react";
import { loaderService } from "../services/loaderService";

export const LoaderContext = createContext({
  loading: false,
  // optional helpers if you want components to show/hide directly
  show: () => { },
  hide: () => { },
  reset: () => { }
});

export function LoaderProvider({ children }) {
  const [loading, setLoading] = useState(false);

  // subscribe once to loaderService and keep state in sync
  useEffect(() => {
    const unsubscribe = loaderService.subscribe((isLoading) => {
      setLoading(!!isLoading);
    });
    // cleanup on unmount
    return () => unsubscribe();
  }, []);

  // convenience wrappers that call loaderService (optional)
  const show = useCallback(() => loaderService.show(), []);
  const hide = useCallback(() => loaderService.hide(), []);
  const reset = useCallback(() => loaderService.reset(), []);

  return (
    <LoaderContext.Provider value={{ loading, show, hide, reset }}>
      {children}
    </LoaderContext.Provider>
  );
}
